class s {
  constructor() {
    this.init();
  }
  init() {
    const e = document.querySelector('[data-disruptor-columns]');
    if (e)
      try {
        const t = JSON.parse(e.textContent);
        t > 0 && this.adjustPagination(t);
      } catch (t) {
        console.warn('Failed to parse disruptor columns:', t);
      }
  }
  adjustPagination(e) {
    const t = document.querySelector('.product-grid--disruptor');
    if (!t) return;
    t.classList.add('has-disruptors');
    const n = document.querySelectorAll('.pagination__item--current');
    n.length !== 0 &&
      (n.forEach((o) => {
        const r = o.textContent.trim(),
          i = parseInt(r, 10);
        isNaN(i) ||
          (o.setAttribute('data-disruptor-present', 'true'),
          o.setAttribute('title', `${e} disruptor tile${e > 1 ? 's' : ''} on this page`));
      }),
      this.updateProductCount(e));
  }
  updateProductCount(e) {
    const t = document.getElementById('ProductCount');
    if (!t) return;
    const n = t.textContent,
      o = n.match(/(\d+)(?:\s+of\s+(\d+))?\s+products?/i);
    if (o) {
      const r = ` (includes ${e} disruptor tile${e > 1 ? 's' : ''} on this page)`;
      o[2]
        ? (t.textContent = n.replace(/(\d+)\s+of\s+(\d+)\s+products?/i, `$1 of $2 products${r}`))
        : (t.textContent = n.replace(/(\d+)\s+products?/i, `$1 products${r}`));
    }
  }
}
document.addEventListener('DOMContentLoaded', () => {
  new s();
});
document.addEventListener('shopify:section:load', () => {
  new s();
});
